<template >
  <div class="marBot10 clear">
    <div class="marBot10 clear" style="width: 786px">
      <div class="l">
        <b class="fontB font12">Shipment units：</b>
        <el-radio
          class="marL10"
          @change="changeUnit"
          v-model="volumeUnit"
          :label="0"
        >
          <span class="font12">KG/CBM</span>
        </el-radio>
        <el-radio
          v-model="volumeUnit"
          @change="changeUnit"
          :label="1"
          style="margin-left: 161px"
        >
          <span class="font12">LB/CFT</span>
        </el-radio>
      </div>
      <!-- <div class="total r">
        <p>
          <span>Shipment total: </span>
          <em class="marR20">{{ sumUnit }} Unit</em>
          <em class="marR10">{{ InterceptUnit(sumKG, 3) }} KG</em>
          <em class="min-em">{{ InterceptUnit(sumCBM, 4) }} CBM</em>
        </p>
        <p>
          <em class="marR10">{{ InterceptUnit(sumLB, 3) }} LB</em>
          <em class="min-em">{{ InterceptUnit(sumCFT, 4) }} CFT</em>
        </p>
      </div> -->
    </div>
    <ul style="margin-left: 117px">
      <li v-for="(item, index) in radCargo" :key="index" class="clear marBot10">
        <div class="clear l" :class="{ borColRed: !item.quanlity }">
          <div class="clear l marR20">
            <input
              style="width: 113px"
              class="inputAll w1"
              type="text"
              maxlength="4"
              placeholder="Same packages"
              @keyup="intNum(index, 'quanlity')"
              @blur="noZero(index, 'quanlity')"
              v-model="item.quanlity"
              v-on:input="changeUnit"
            />
            <p class="rigW" style="width: 113px; overflow: hidden">
              <el-select v-model="item.unit" class="unit_select">
                <el-option
                  v-for="item in item.unitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </p>
          </div>
          <div v-show="!item.quanlity" class="colRed">required</div>
        </div>
        <div class="clear l">
          <div
            class="clear l marR20"
            :class="{ borColRed: !item.length || !item.width || !item.height }"
          >
            <input
              class="inputRad radL"
              type="text"
              style="width: 68px"
              placeholder="Length"
              @keyup="item.length = clearNoNum(item.length)"
              @blur="noZero(index, 'length')"
              v-model="item.length"
              v-on:input="changeUnit"
            />
            <input
              class="inputRad radC"
              type="text"
              style="width: 68px"
              placeholder="Width"
              @keyup="item.width = clearNoNum(item.width)"
              @blur="noZero(index, 'width')"
              v-model="item.width"
              v-on:input="changeUnit"
            />
            <input
              class="inputRad radR"
              type="text"
              style="width: 68px"
              placeholder="Height"
              @blur="noZero(index, 'height')"
              @keyup="item.height = clearNoNum(item.height)"
              v-model="item.height"
              v-on:input="changeUnit"
            />
            <p class="rigW">{{ volumeUnit === 0 ? "CM" : "IN" }}</p>
          </div>
          <div
            v-show="!item.length || !item.width || !item.height"
            class="colRed"
          >
            required
          </div>
        </div>
        <div class="clear l">
          <div class="clear l marR10" :class="{ borColRed: !item.weight }">
            <input
              style="width: 182px"
              class="inputAll w1"
              type="text"
              placeholder="Weight of one box"
              @blur="noZero(index, 'weight')"
              @keyup="item.weight = clearNoNum(item.weight)"
              v-model="item.weight"
              v-on:input="changeUnit"
            />
            <p class="rigW">{{ volumeUnit === 0 ? "KG" : "LB" }}</p>
          </div>
          <div v-show="!item.weight" class="colRed">required</div>
        </div>
        <label class="icon_aa">
          <i
            v-show="radCargo.length != 0"
            class="fa fa-failure colRed font14"
            style="
              font-size: 15px !important;
              vertical-align: top;
              line-height: 30px;
            "
            :class="{ isNone: radCargo.length == 1 }"
            @click="delPackage(index)"
          ></i>
          <i
            v-show="index == radCargo.length - 1"
            class="fa fa-add colBlue font14"
            style="line-height: 30px; vertical-align: top; margin-top: 1px"
            @click="addPackage()"
          ></i>
          <span v-show="radCargo.length == 1">Add another unit</span>
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
//详细货物信息
import { byBoxs } from "@/utils/transfromUnit.js";
import EventBus from "@/ask/eventBus";
export default {
  props: ["value"],

  mixins: [byBoxs], //混入该方法 功能是：计算单位转换
  model: {
    prop: "value",
    event: "sendByBoxs",
  },

  data() {
    return {
      radCargo: [
        {
          quanlity: "",
          length: "",
          width: "",
          height: "",
          weight: "",
          unitOptions: [
            { value: 1, label: "Carton" },
            { value: 2, label: "Pallet" },
            { value: 3, label: "Wooden Case" },
            { value: 4, label: "Other" },
          ],
          unit: 1,
        },
      ],
      volumeUnit: 0,
    };
  },
  watch: {
    // 将值传给v-model
    radCargo: {
      deep: true,
      handler: function (newV, oldV) {
        this.changeUnit();
      },
    },
  },
  computed: {
    sumCBM() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if (this.volumeUnit == 0) {
          num +=
            ((Number(e.length) * Number(e.width) * Number(e.height)) /
              1000000) *
            Number(e.quanlity);
        } else {
          num +=
            Number(e.length) *
            Number(e.width) *
            Number(e.height) *
            Number(e.quanlity) *
            0.000016387064;
        }
      });
      return Number(num) || 0;
    },
    sumCFT() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if (this.volumeUnit == 0) {
          num +=
            ((Number(e.length) * Number(e.width) * Number(e.height)) /
              1000000) *
            Number(e.quanlity) *
            35.3147248;
        } else {
          num +=
            Number(e.length) *
            Number(e.width) *
            Number(e.height) *
            0.000016387064 *
            35.3147248 *
            e.quanlity;
        }
      });
      return Number(num) || 0;
    },
    sumUnit() {
      let num = 0;
      this.radCargo.forEach((e) => {
        num += Number(e.quanlity);
      });
      return Number(num) || 0;
    },
    sumKG() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if (this.volumeUnit == 0) {
          num += Number(e.quanlity) * Number(e.weight);
        } else {
          num += Number(e.quanlity) * (Number(e.weight) * 0.4535924);
        }
      });
      return Number(num) || 0;
    },
    sumLB() {
      let num = 0;
      this.radCargo.forEach((e) => {
        if (this.volumeUnit == 0) {
          num += Number(e.quanlity) * (Number(e.weight) * 2.2046226);
        } else {
          num += Number(e.quanlity) * Number(e.weight);
        }
      });
      return Number(num) || 0;
    },
  },

  methods: {
    addPackage() {
      //增加包裹
      this.radCargo.push({
        quanlity: "",
        length: "",
        width: "",
        height: "",
        Weight: "",
        unitOptions: [
          { value: 1, label: "Carton" },
          { value: 2, label: "Pallet" },
          { value: 3, label: "Wooden Case" },
          { value: 4, label: "Other" },
        ],
        unit: 1,
      });
    },
    delPackage(index) {
      if (this.radCargo.length > 1) {
        this.radCargo.splice(index, 1);
      }
    },
    clearNoNum(ctrValue) {
      if (ctrValue) {
        //ctrValue = ctrValue.replace(/^\./g, ""); //验证第一个字符是数字而不是.
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 7) {
          let int = arr[0].substring(0, 7);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
        return ctrValue;
      }
    },
    noZero(i, value) {
      if (!this.radCargo[i][value] == "") {
        this.$emit("sumbitQuery");
      }
      if (this.radCargo[i][value] == 0) {
        this.radCargo[i][value] = "";
      }
    },
    intNum(i, value) {
      if (this.radCargo[i][value].length == 1) {
        this.radCargo[i][value] = this.radCargo[i][value].replace(
          /[^1-9]/g,
          ""
        );
      } else {
        this.radCargo[i][value] = this.radCargo[i][value].replace(/\D/g, "");
      }
    },
    changeUnit() {
      let newValue = {
        radCargo: this.radCargo,
        total: {
          sumUnit: this.sumUnit,
          sumKG: this.sumKG,
          sumCBM: this.sumCBM,
          sumLB: this.sumLB,
          sumCFT: this.sumCFT,
        },
        volumeUnit: this.volumeUnit,
      };
      this.$emit("sendByBoxs", newValue);
      EventBus.$emit("aMsg", newValue);
    },
  },
};
</script>
<style >
.unit_select .el-input__inner {
  border: none !important;
  background: #f7f7f7 !important;
  padding-left: 6px !important;
  font-size: 12px !important;
}
.unit_select .el-input__suffix {
  right: 0 !important;
}
</style>
<style scoped>
@import "../../../../assets/css/userCenterCss.css";
.icon_aa {
  line-height: 30px;
}
.total {
  text-align: right;
  font-size: 12px;
}
.fontB {
  font-weight: bold;
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/reception/air/query/calculateByBoxes.vue